import { useContext } from 'react';

import { ProctorRequestDetailsContext } from './proctor-request-details-provider';

function useProctorRequestDetails() {
  const context = useContext(ProctorRequestDetailsContext);

  if (!context) {
    throw new Error('useProctorRequestDetails must be used within a ProctorRequestDetailsProvider');
  }

  return context;
}

export { useProctorRequestDetails };
